import React, { useState } from 'react'
import Lightbox from 'react-18-image-lightbox';
import { getFileName } from '../helper/getFileName';
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function HorseGallery({ data }) {
    const [images, setImages] = useState(reformatImages(data));
    const [imageslightbox, setImageslightbox] = useState(reformatImages(data));

    function reformatImages(images) {
        return (
            images.map((image, index) => ({
                src: MediaBaseURL + image.url,
                width: image.width,
                height: image.height,
                isvideo: image.mediaType == "Image" ? false : true,
                tags: image.isvideo ? [
                    { value: <i className=" fa-solid fa-play" style={{ fontSize: 18 }}></i> },
                ] : [],
            }))
        );
    }

    const [index, setIndex] = useState(-1);

    const currentImage = images[index];
    const nextIndex = (index + 1) % images.length;
    const nextImage = images[nextIndex] || currentImage;
    const prevIndex = (index + images.length - 1) % images.length;
    const prevImage = images[prevIndex] || currentImage;

    const handleClick = (index) => setIndex(index);
    const handleClose = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);

    function getVideoFrame(index) {
        return (<iframe width="90%" height="90%" src={imageslightbox[index].src} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>);
    }


    return (
        <div className='row mx-0 rtl align-items-center'>
            {data.map((item, index) => (
                item.mediaType == "umbracoMediaVideo" ?
                    < div className='col-lg-4 col-md-6 col-sm-12 mb-main border-15' style={{ overflow: 'hidden' }}>
                        <video src={`${MediaBaseURL}${item.url}`} height={250} controls className='w-100 border-15' style={{ cursor: 'pointer' }} />
                    </div>
                    :
                    < div className='col-lg-4 col-md-6 col-sm-12 mb-main border-15' style={{ overflow: 'hidden' }} >
                        <img src={`${MediaBaseURL}${item.url}`} alt={getFileName(item?.url)} height={250} onClick={() => handleClick(index)} className='w-100 border-15' style={{ cursor: 'pointer' }} />
                    </div>
            ))
            }
            {!!currentImage && (
                /* @ts-ignore */
                <Lightbox
                    mainSrc={imageslightbox[index].src}
                    wrapperClassName='ltr'
                    onCloseRequest={handleClose}
                    imageLoadErrorMessage={getVideoFrame(index)}
                />
            )}
        </div >
    )
}
